import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { LoaderService, ToastService } from '@mtgame/ui';
import { isPlatformBrowser } from '@angular/common';
import { GameTimelineService } from '@core/services/game-timeline.service';

@Injectable()
export class TournamentGameTimelineResolver implements Resolve<any> {
  constructor(
    @Inject(PLATFORM_ID) private platformId: string,
    private gameTimelineService: GameTimelineService,
    private loaderService: LoaderService,
    private toastService: ToastService,
  ) {
  }

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<any>{
    this.loaderService.show();
    if (!isPlatformBrowser(this.platformId)) {
      return Promise.resolve();
    }
    try {
      return await this.gameTimelineService.initialize();
    } catch (e) {
      this.toastService.danger('Произошла ошибка');
      throw e;
    } finally {
      this.loaderService.hide();
    }
  }
}
